import { DateRange } from './DateRange';
import { isEmptyDateRange } from './isEmptyDateRange';

export function ensureDateRange<T extends Date | string = Date>(
  candidate: Partial<DateRange<T>> | DateRange<T>
): asserts candidate is DateRange<T> {
  if (isEmptyDateRange(candidate)) {
    throw new Error(`Candidate: ${JSON.stringify(candidate)} is not a complete DateRange`);
  }
}
